export enum SELLER_TYPES {
  ALL = 'A',
  INTERNAL = 'I',
  EXTERNAL = 'E',
}
